export default "__VITE_ASSET__6sKrQ28R__"